import { cwslapi } from "../index";

// 获取七夕活动信息
export const getActivityInfoApi = (data) => {
  return cwslapi({
    url: "/qixiActivity/getActivityInfo",
    method: "post",
    data,
  });
};

// 金龙元宝兑换同心结
export const exchangeApi = (data) => {
  return cwslapi({
    url: "/qixiActivity/exchange",
    method: "post",
    data,
  });
};

// 七夕活动抽奖
export const drawApi = (data) => {
  return cwslapi({
    url: "/qixiActivity/draw",
    method: "post",
    data,
  });
};

// 购买隐藏商店商品
export const buyHiddenShopItemApi = (data) => {
  return cwslapi({
    url: "/qixiActivity/buyHiddenShopItem",
    method: "post",
    data,
  });
};
